<script>
	import { onDestroy, getContext } from 'svelte'
	import { url } from '../library/scripts/Setup.svelte'
	import { styles } from '../library/scripts/styles'
	import { getCookie } from '../library/scripts/cookie'
	import { storeBuilderPreview, storeShowTools, storeElementID, storeData } from '../library/scripts/Store.svelte'
	import IntersectionObserver from 'svelte-intersection-observer'

	export let blockName = null

	let path
	let logoPath

	//observer
	let element
	let large = false
	const set_observer = (e) => {
		if (e === 'set') {
			large = false
			element.style.filter = 'blur(5px)'
		} else {
			large = true
			element.style.filter = 'blur(0px)'
		}
	}

	let configFile
	let block

	const stoData = storeData.subscribe((value) => {
		if (value) {
			configFile = value
			value.blocks.forEach((item) => {
				if (item.blockName === blockName) {
					block = item
				}
			})
		}
	})

	const globals = getContext('globals')
	const fsS = globals.fsS
	const devWidth = globals.devWidth
	const isMobi = globals.mobi
	const builderToolbar = globals.builderToolbar
	const builderToolbarHover = globals.builderToolbarHover

	//the folder from which to take images
	let folder

	//logo stuff
	const hasLogo = block.hasLogo

	if (!isMobi) {
		if (devWidth >= 1200) folder = '/large/'
		if (devWidth < 1200 && devWidth >= 800) folder = '/medium/'
		if (devWidth < 800) folder = '/small/'
	}
	// mobile devices
	if (isMobi) {
		if (devWidth < 1440 && devWidth >= 800) folder = '/medium/'
		else folder = '/small/'
	}

	let userAdmin = getCookie('id')

	path = url + '/' + blockName + folder + block.content[0].image
	if (hasLogo) {
		logoPath = url + '/logo' + folder + configFile.logo.image
	}

	path = url + '/' + blockName + folder + block.content[0].image

	let elementID = null

	//responsive for very small window width
	let deviceWidth
	let titleSize

	//small devices
	$: if (deviceWidth <= 799) {
		titleSize = fsS
	}

	$: if (deviceWidth <= 800 && deviceWidth > 1148) {
		titleSize = fsN
	}

	$: if (deviceWidth >= 1148) {
		titleSize = block.sibTitleFontSize
	}

	let showPreview
	const stoPreview = storeBuilderPreview.subscribe((value) => {
		showPreview = value
	})
	let showTools
	const stoShowTools = storeShowTools.subscribe((value) => {
		showTools = value
	})

	const set_elementID = (e) => {
		storeShowTools.set(true)
		elementID = e
		storeElementID.set(e)
	}

	onDestroy(() => {
		stoPreview
		stoShowTools
		stoData
		storeShowTools.set(false)
	})
</script>

<svelte:window bind:innerWidth={deviceWidth} />
{#if configFile}
	{#if !showPreview}
		<div
			class="content_row"
			use:styles={{ fsS, builderToolbar, builderToolbarHover }}
			on:click={() => set_elementID(block.blockName + '_singleImageBlock')}
			on:keydown={() => set_elementID(block.blockName + '_singleImageBlock')}
		>
			<div style="margin-left:20px;">*OPEN FULL SIZE BLOCK TOOL*</div>
		</div>
	{/if}

	<IntersectionObserver
		{element}
		threshold="0.3"
		on:observe={(e) => {
			if (!e.detail.isIntersecting) {
				set_observer('set')
			} else {
				set_observer('unset')
			}
		}}
	>
		<div
			bind:this={element}
			id={block.blockName}
			style="
			display: block;
			position:relative;
			width:{block.sibWidth}%;
			height:{block.sibHeight}vw;
			margin-top:{block.sibMarginTop}%;
			margin-bottom:{block.sibMarginBottom}%;
			padding:{block.sibPadding}%;
			box-shadow: {block.sibShadowOffsetX}px {block.sibShadowOffsetY}px {block.sibShadowBlur}px {block.sibShadowColor};
			background-color:{block.sibBackgroundColor};
			border-left: {block.sibBorderLeftWidth}px {block.sibBorderLeftStyle} {block.sibBorderLeftColor};
			border-top: {block.sibBorderTopWidth}px {block.sibBorderTopStyle} {block.sibBorderTopColor};
			border-right: {block.sibBorderRightWidth}px {block.sibBorderRightStyle} {block.sibBorderRightColor};
			border-bottom: {block.sibBorderBottomWidth}px {block.sibBorderBottomStyle} {block.sibBorderBottomColor};
			border-top-left-radius:{block.sibBorderTopRadius}px;
			border-top-right-radius:{block.sibBorderTopRadius}px;
			border-bottom-left-radius:{block.sibBorderBottomRadius}px;
			border-bottom-right-radius:{block.sibBorderBottomRadius}px;
			z-index:0;
			"
		>
			{#if hasLogo}
				<div
					style="
					position:absolute;
					display:inline-block;
					height:{configFile.logo.imageHeight}%;
					object-fit:{configFile.logo.objectFit};
					top:{configFile.logo.top}%;
					left:{configFile.logo.left}%;;
					background-color:{configFile.logo.backgroundColor};
					z-index:1;
					"
				>
					<img src={logoPath} alt="logo" height="100%" />
				</div>
			{/if}
			<img
				src={path}
				alt="fullSize"
				style="
				position:absolute;
				left:{block.sibImageLeft}%;
				top:{block.sibImageTop}%;
				width:{block.sibImageWidth}%; 
				height:{block.sibImageHeight}%;
				object-fit:stretch;
				border-left: {block.sibImageBorderLeftWidth}px {block.sibImageBorderStyle} {block.sibImageBorderLeftColor};
				border-top: {block.sibImageBorderTopWidth}px {block.sibImageBorderStyle} {block.sibImageBorderTopColor};
				border-right: {block.sibImageBorderRightWidth}px {block.sibImageBorderStyle} {block.sibImageBorderRightColor};
				border-bottom: {block.sibImageBorderBottomWidth}px {block.sibImageBorderStyle} {block.sibImageBorderBottomColor};
				border-top-left-radius:{block.sibImageBorderTopRadius}px;
				border-top-right-radius:{block.sibImageBorderTopRadius}px;
				border-bottom-left-radius:{block.sibImageBorderBottomRadius}px;
				border-bottom-right-radius: {block.sibImageBorderBottomRadius}px;
				box-shadow: {block.sibImageShadowOffsetX}px {block.sibImageShadowOffsetY}px {block.sibImageShadowBlur}px {block.sibImageShadowColor};
				text-shadow: {block.sibTitleTXTSX}px {block.sibTitleTXTSY}px  {block.sibTitleTXTSB}px {block.sibTitleTXTSC}
				"
			/>
			{#if block.content[0].title}
				<div
					id={block.sibTitleId}
					style="
					display:flex;
					align-items:{block.sibTitleAlign};
					justify-content:{block.sibTitleJustify};
					position:absolute;
					top:{block.sibTitleTop}%;
					left:{block.sibTitleLeft}%;
					height:{block.sibTitleHeight}%;
					width:{block.sibTitleWidth}%;
					padding: {block.sibTitlePadding}%;
					background:{block.sibTitleBackground};
					font-family: {block.sibTitleFontFamily};
					font-size: {titleSize};
					font-weight:{block.sibTitleFontWeight};
					font-style:{block.sibTitleFontStyle};
					text-decoration:{block.sibTitleFontDeco};
					color: {block.sibTitleFontColor};
					border-left: {block.sibTitleBorderLeftWidth}px {block.sibTitleBorderStyle} {block.sibTitleBorderLeftColor};
					border-top: {block.sibTitleBorderTopWidth}px {block.sibTitleBorderStyle} {block.sibTitleBorderTopColor};
					border-right: {block.sibTitleBorderRightWidth}px {block.sibTitleBorderStyle} {block.sibTitleBorderRightColor};
					border-bottom: {block.sibTitleBorderBottomWidth}px {block.sibTitleBorderStyle} {block.sibTitleBorderBottomColor};
					border-top-left-radius:{block.sibTitleBorderTopRadius}px;
					border-top-right-radius:{block.sibTitleBorderTopRadius}px;
					border-bottom-left-radius:{block.sibTitleBorderBottomRadius}px;
					border-bottom-right-radius: {block.sibTitleBorderBottomRadius}px;
					box-shadow: {block.sibTitleShadowOffsetX}px {block.sibTitleShadowOffsetY}px {block.sibTitleShadowBlur}px {block.sibTitleShadowColor};
					text-shadow: {block.sibTitleTXTSX}px {block.sibTitleTXTSY}px  {block.sibTitleTXTSB}px {block.sibTitleTXTSC}
					"
				>
					{block.content[0].title}
				</div>
			{/if}
			{#if deviceWidth > 568}
				{#if block.content[0].text}
					<div
						id={block.sibTextId}
						style="
						display:flex;
						align-items:{block.sibTextAlign};
						justify-content:{block.sibTextJustify};
						position:absolute;
						top:{block.sibTextTop}%;
						left:{block.sibTextLeft}%;
						height:fit-content;
						width:{block.sibTextWidth}%;
						padding: {block.sibTextPadding}%;
						background:{block.sibTextBackground};
						font-family: {block.sibTextFontFamily};
						font-size: {block.sibTextFontSize};
						font-weight:{block.sibTextFontWeight};
						font-style:{block.sibTextFontStyle};
						text-decoration:{block.sibTextFontDeco};
						color: {block.sibTextFontColor};
						border-left: {block.sibTextBorderLeftWidth}px {block.sibTextBorderStyle} {block.sibTextBorderLeftColor};
						border-top: {block.sibTextBorderTopWidth}px {block.sibTextBorderStyle} {block.sibTextBorderTopColor};
						border-right: {block.sibTextBorderRightWidth}px {block.sibTextBorderStyle} {block.sibTextBorderRightColor};
						border-bottom: {block.sibTextBorderBottomWidth}px {block.sibTextBorderStyle} {block.sibTextBorderBottomColor};
						border-top-left-radius:{block.sibTextBorderTopRadius}px;
						border-top-right-radius:{block.sibTextBorderTopRadius}px;
						border-bottom-left-radius:{block.sibTextBorderBottomRadius}px;
						border-bottom-right-radius: {block.sibTextBorderBottomRadius}px;
						box-shadow: {block.sibTextShadowOffsetX}px {block.sibTextShadowOffsetY}px {block.sibTextShadowBlur}px {block.sibTextShadowColor};
						user-select:text;
						white-space:pre-wrap;
						text-align:{block.sibTextAlign};
						"
					>
						{block.content[0].text}
					</div>
				{/if}
			{/if}
		</div>

		{#if deviceWidth <= 568}
			{#if block.content[0].text}
				<div
					id={block.sibTextId}
					style="
					display:flex;
					align-items:{block.sibTextAlign};
					justify-content:{block.sibTextJustify};
					position:relative;
					height:fit-content;
					width:100%;
					padding: {block.sibTextPadding}%;
					background:{block.sibTextBackground};
					font-family: {block.sibTextFontFamily};
					font-size: {block.sibTextFontSize};
					font-weight:{block.sibTextFontWeight};
					font-style:{block.sibTextFontStyle};
					text-decoration:{block.sibTextFontDeco};
					color: {block.sibTextFontColor};
					border-left: {block.sibTextBorderLeftWidth}px {block.sibTextBorderStyle} {block.sibTextBorderLeftColor};
					border-top: {block.sibTextBorderTopWidth}px {block.sibTextBorderStyle} {block.sibTextBorderTopColor};
					border-right: {block.sibTextBorderRightWidth}px {block.sibTextBorderStyle} {block.sibTextBorderRightColor};
					border-bottom: {block.sibTextBorderBottomWidth}px {block.sibTextBorderStyle} {block.sibTextBorderBottomColor};
					border-top-left-radius:{block.sibTextBorderTopRadius}px;
					border-top-right-radius:{block.sibTextBorderTopRadius}px;
					border-bottom-left-radius:{block.sibTextBorderBottomRadius}px;
					border-bottom-right-radius: {block.sibTextBorderBottomRadius}px;
					box-shadow: {block.sibTextShadowOffsetX}px {block.sibTextShadowOffsetY}px {block.sibTextShadowBlur}px {block.sibTextShadowColor};
					user-select:text;
					white-space:pre-wrap;
					"
				>
					{block.content[0].text}
				</div>
			{/if}
		{/if}
	</IntersectionObserver>
{/if}

<style>
	.content_row {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		width: 100%;
		cursor: pointer;
		font-style: italic;
		font-size: var(--fsS);
		background-color: var(--builderToolbar);
		height: 40px;
		border-bottom: 1px solid hsl(0, 0%, 50%);
	}

	.content_row:hover {
		background-color: var(--builderToolbarHover);
	}
</style>
